export default "__VITE_ASSET__84d65dbb__"